<template>
  <section :class="{active: isLoaded}">
    <div class="header">
      <RaceCounterComponent/>
      <RaceHeaderComponent/>
    </div>
    <RaceBodyComponent/>
  </section>
</template>

<script>
// @ is an alias to /src
import RaceCounterComponent from "@/components/RaceCounter.vue";
import RaceHeaderComponent from "@/components/RaceHeader.vue";
import RaceBodyComponent from "@/components/RaceBody.vue";

export default {
  name: "Race",
  components: {
    RaceCounterComponent,
    RaceHeaderComponent,
    RaceBodyComponent
  },
  data() {
    return {
      isLoaded: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("getData").then(statusCode => {
        if (this.$store.state.status === "after_race") {
          this.$router.replace("/result");
        } else if (this.$store.state.status === "ranking") {
          this.$router.replace("/after");
        } else {
          this.isLoaded = true;
          setTimeout(() => {
            this.getData();
          }, 10000);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
section {
  visibility: hidden;
  &.active {
    visibility: visible;
  }
}
.header {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
